import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';
import SmileySVG from './smiley-smile-1.svg';
import { Box } from '@backstage/ui';
import { Text } from '@backstage/ui';
import { LinkButton } from '@backstage/core-components';

type Quarter = {
  title: string;
  toDate: Date;
}
/**
 * Calculates the quarter to a given date.
 * @param date the reference date
 */
export const getNextQuarter = (date: Date): Quarter => {
  // we have no API yet, so we just recreate the logic ourselves:
  // 1. Mai - 31. Juli = Q I
  // 1. August - 31. Oktober = Q II
  // 1. November - 31. Januar = Q III
  // 1. Februar - 30. April = Q IV
  const month = date.getMonth() + 1; // Months are zero-based, so add 1
  const year = date.getFullYear();
  switch (true) {
      case month >= 2 && month <= 4:
          return {title: `Q IV ${(year - 1).toString()}/${(year).toString()}`, toDate: new Date(year, 3, 30)};
      case month >= 5 && month <= 7:
          return {title: `Q I ${year.toString()}/${(year + 1).toString()}`, toDate: new Date(year, 6, 31)};
          case month >= 8 && month <= 10:
        return {title: `Q II ${year.toString()}/${(year + 1).toString()}`, toDate: new Date(year, 9, 31)};
      default: {
        const theYear = date.getMonth() > 0 ? date.getFullYear() + 1 : date.getFullYear();
        return {title: `Q III ${year.toString()}/${(year + 1).toString()}`, toDate: new Date(theYear, 0, 31)};
      }
  }
}

export default function MexxiInfoCard() {
  const date = new Date();
  const quarter = getNextQuarter(date);
  const differenceInMs = quarter.toDate.getTime() - date.getTime();
  const differenceInDays = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));
  
  return (
    <Box
      style={{
        height: '100%',
        backgroundColor: '#9d599f',
        borderRadius: '12px',
        padding: '24px',
        display: 'flex',
        flexDirection: 'row',
        gap: '24px',
        alignItems: 'center',
      }}
    >
      {/* Left column — image */}
      <Box style={{ flexShrink: 0 }}>
        <img
          src={SmileySVG}
          alt="Clock Logo"
          style={{ width: '64px', height: '64px' }}
        />
      </Box>

      {/* Right column — stacked text + action */}
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
        }}
      >
        <Text variant="title-large" style={{ color: '#FFFFFF', display: 'block' }}>
          MeXXi
        </Text>
        <Text variant="title-x-small" style={{ color: '#FFFFFF', opacity: 0.85, display: 'block' }}>
          {quarter.title}
        </Text>
        <Text variant="body-small" style={{ color: '#FFFFFF', opacity: 0.7, display: 'block' }}>
          You have {differenceInDays} days left.
        </Text>        
      </Box>
    </Box>
  );
}

export const Content = MexxiInfoCard;
export const Actions = function WelcomeActions() {
  return (
    <LinkButton 
      target="blank" 
      to='https://apps.exxcellent.de/mexxi/app'
    >Open meXXi</LinkButton>
  )
}

export const mexxiWidget = HomePageWidgetBlueprint.make({
  name: 'mexxi-widget',
  params: {
    name: 'MexxiWidget',        
    description: 'A Mexxi widget for the homepage',
    components: () =>
      import('./MexxiInfoCard').then(m => ({
        Content: m.Content,  
        Actions: m.Actions      
      })),      
    layout: {
      height: { minRows: 5, defaultRows: 5 },
      width: { minColumns: 3, defaultColumns: 3 },
    },    
  },
})as any;

